/**
 * <s-smile-link data-deep-link="home"><a href="#smile-home">…</a></s-smile-link>
 *
 * Opens the Smile.io rewards panel (drawn by the official Smile app embed) using Smile's
 * documented methods (https://dev.smile.io/ui/panel/deep-links):
 *  - When Smile's JavaScript SDK is available, calls SmileUI.openPanel({ deep_link }).
 *  - Otherwise relies on Smile's anchor deep link (#smile-…) already in the href. The hash
 *    is cleared first so a second click on the same link still opens the panel.
 * Reads or changes no points, rewards or customer data; Smile's panel handles all of it.
 */
class SmileLink extends HTMLElement {
  #ac;

  connectedCallback() {
    const link = this.querySelector('a[href^="#smile-"]');
    if (!link) return;
    this.#ac = new AbortController();
    link.addEventListener('click', (event) => this.#open(event, link), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #open(event, link) {
    const deepLink = this.dataset.deepLink;
    const smile = window.SmileUI;
    event.preventDefault();

    if (smile && typeof smile.openPanel === 'function') {
      smile.openPanel(deepLink ? { deep_link: deepLink } : undefined);
      return;
    }

    const hash = link.getAttribute('href');
    if (window.location.hash === hash) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    window.location.hash = hash;
  }
}

if (!customElements.get('s-smile-link')) customElements.define('s-smile-link', SmileLink);
